import { useState, useCallback } from "react";
import { useAuthenticatedFetchWithWorkspace } from "../../Keycloak/useAuthenticatedFetchWithWorkspace";

export interface MoveCustomerStorePayload {
    identifierValue: string;
    entityId: string | number;
    motif: string;
    personIdentifierTypeId: string | number;
}

const useMoveCustomerStore = () => {
    const { authFetch, isReady } = useAuthenticatedFetchWithWorkspace();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string>("");

    const moveCustomerStore = useCallback(
        async (payload: MoveCustomerStorePayload): Promise<boolean> => {
            if (!isReady) return false;
            setIsLoading(true);
            setError("");
            try {
                const raw = await authFetch("/batchesMoveEntity", {
                    method: "POST",
                    body: JSON.stringify({
                        identifierValue: String(payload.identifierValue),
                        entityId: String(payload.entityId),
                        motif: payload.motif || "CHANGEMENT DE MAGASIN",
                        personIdentifierTypeId: String(payload.personIdentifierTypeId),
                    }),
                });

                if (!raw) {
                    setError("Le changement de magasin a échoué.");
                    return false;
                }
                return true;
            } catch (err: unknown) {
                setError(err instanceof Error ? err.message : "Une erreur est survenue");
                return false;
            } finally {
                setIsLoading(false);
            }
        },
        [authFetch, isReady]
    );

    return { moveCustomerStore, isLoading, error };
};

export default useMoveCustomerStore;
